import { components } from 'react-select';
import { useModalStack } from './ModalStackProvider';
import styles from './ModalStack.module.css';

export const CustomMenu = (
  props,
  modalToPush,
  modalToPushProps,
  addItemText
) => {
  const { children } = props;
  const { pushModal } = useModalStack();

  return (
    <components.Menu {...props}>
      <div
        className={styles['add-item-btn']}
        onClick={() =>
          pushModal({ component: modalToPush, props: modalToPushProps })
        }
      >
        {addItemText}
      </div>
      {children}
    </components.Menu>
  );
};
